import axios from 'axios'

const configs = async () => {
  var response = await axios.create().get('/config/config-env.json', { params: { v: (Math.round(Math.random() * 100))} })
  return response.data
}

export default configs